import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useApp } from '../../context/AppContext';
import { generateArticleUrl } from '../../utils/urlHelper';

const Hero = ({ articles, featuredArticles }) => {
    const navigate = useNavigate();
    const { sections } = useApp();

    // Check if hero section is enabled
    const heroSection = sections.find(s => s.id === 'hero');
    if (heroSection && heroSection.enabled === false) {
        return null; // Don't render hero if disabled
    }

    const mainArticle = featuredArticles[0] || articles[0];
    const sideArticles = featuredArticles.slice(1, 3).length ? featuredArticles.slice(1, 3) : articles.slice(1, 3);

    const openArticle = (article) => {
        // ✅ Use slug if available, fallback to _id
        navigate(generateArticleUrl(article));
    };

    if (!mainArticle) return null;

    return (
        <div className="hero-grid" style={{ display: 'grid', gridTemplateColumns: '2fr 1fr', gridTemplateRows: 'auto auto', gap: '4px', margin: '20px 0', borderRadius: '4px', overflow: 'hidden' }}>
            <div className="hero-main" style={{ gridRow: '1/3', position: 'relative', cursor: 'pointer', height: '440px' }} onClick={() => openArticle(mainArticle)}>
                <img src={mainArticle.img || mainArticle.imgData || 'https://via.placeholder.com/800x440'} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                <div className="hero-overlay" style={{ position: 'absolute', bottom: 0, left: 0, right: 0, background: 'linear-gradient(transparent, rgba(0,0,0,.85))', padding: '20px' }}>
                    <span className="tag">{mainArticle.category}</span>
                    <h2 style={{ color: '#fff', fontFamily: 'var(--ff-head)', fontSize: '22px', lineHeight: '1.3', marginTop: '6px' }}>{mainArticle.title}</h2>
                    <div className="meta" style={{ color: '#aaa', fontSize: '12px', marginTop: '6px' }}>✍️ {mainArticle.author} · 📅 {mainArticle.date}</div>
                </div>
            </div>
            {sideArticles.map((article, idx) => (
                <div key={idx} className="hero-side" style={{ position: 'relative', cursor: 'pointer', height: '218px', overflow: 'hidden' }} onClick={() => openArticle(article)}>
                    <img src={article.img || article.imgData || 'https://via.placeholder.com/400x218'} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                    <div className="hero-overlay" style={{ position: 'absolute', bottom: 0, left: 0, right: 0, background: 'linear-gradient(transparent, rgba(0,0,0,.85))', padding: '15px' }}>
                        <span className="tag">{article.category}</span>
                        <h3 style={{ color: '#fff', fontFamily: 'var(--ff-head)', fontSize: '16px', lineHeight: '1.3', marginTop: '6px' }}>{article.title}</h3>
                    </div>
                </div>
            ))}
        </div>
    );
};

export default Hero;